import { fetch, schemas } from '../utils/fetch'
import { ENDPOINT_IMAGE, ENDPOINT_FLAG_IMAGE, ENDPOINT_RATE_IMAGE } from '../constants'

const FETCH_IMAGE_REQUEST = 'blayzr/image/REQUEST'
const FETCH_IMAGE_SUCCESS = 'blayzr/image/SUCCESS'
const FETCH_IMAGE_FAILURE = 'blayzr/image/FAILURE'

const FLAG_IMAGE = 'blayzr/image/FLAG'
const RATE_IMAGE = 'blayzr/image/RATE'

// No reducer needed because everything is
// handled by the entities reducer

function fetchImageRequest (id) {
  return {
    type: FETCH_IMAGE_REQUEST,
    payload: { entities: { images: { [id]: {
      fetching: true,
      error: null
    } } } }
  }
}

function fetchImageSuccess (id, data) {
  return {
    type: FETCH_IMAGE_SUCCESS,
    payload: { entities: { images: { [id]: {
      ...data.entities.images[id],
      fetching: false
    } } } }
  }
}

function fetchImageFailure (id, error) {
  return {
    type: FETCH_IMAGE_FAILURE,
    payload: { entities: { images: { [id]: {
      error: error,
      fetching: false
    } } } }
  }
}

const schema = {
  records: schemas.image
}

export function fetchImage (id) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_IMAGE.replace(':id', id)
    const { auth: { token } } = getState()
    dispatch(fetchImageRequest(id))
    fetch(endpoint, { token, schema }, dispatch).then(data => {
      dispatch(fetchImageSuccess(id, data))
    }, e => {
      dispatch(fetchImageFailure(id, e))
    })
  }
}

export function flagImage (id, body) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_FLAG_IMAGE.replace(':id', id)
    const options = {
      method: 'post',
      token: getState().auth.token,
      body
    }
    dispatch({
      type: FLAG_IMAGE,
      payload: { entities: { images: { [id]: {
        flagged: true
      } } } }
    })
    return fetch(endpoint, options, dispatch)
  }
}

export function rateImage (id, rating) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_RATE_IMAGE.replace(':id', id).replace(':rating', rating)
    const { auth: { token } } = getState()
    dispatch({
      type: RATE_IMAGE,
      payload: { entities: { images: { [id]: {
        rated: rating
      } } } }
    })
    return fetch(endpoint, { token }, dispatch)
  }
}



// WEBPACK FOOTER //
// ./src/redux/image.js